import React from 'react';
import CONSTANTS from '../../Constants';


const VehicleSummary = ({ vehicleName, vehicleMileage, vehicleSerialNumber, onEditClick }) => {
    return (
        <div className='vehicleDetails'>
            <div className='vehicleBlock-title'>{CONSTANTS.LABELS.header_modification_vehicule}</div>
            <div className='vehicleBlock-name' title={vehicleName}>{vehicleName}</div>
            <div className='vehicleBlock-infos'>
                <span className='mileage'>{vehicleMileage} {CONSTANTS.LABELS.account_km2}</span>
                <span className='vin'>{vehicleSerialNumber || '-'} </span>
            </div>
            <div tabIndex='0' role="button" className='edit-link' onClick={() => onEditClick('vehicle')}>{CONSTANTS.LABELS.common_v2_modify}</div>
        </div>
    );

}

export default VehicleSummary;